import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, endpoints } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, CalendarDays, Clock } from "lucide-react";

const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { api.get(`${endpoints.posts}/${slug}`).then(setPost).catch(() => setErr("Not found")); }, [slug]);
  if (err) return <main className="container-wide py-24"><p>Post not found. <Link to="/blog" className="underline text-[hsl(var(--navy))]">Back to blog</Link>.</p></main>;
  if (!post) return <main className="container-wide py-24"><p className="text-[hsl(var(--muted-ink))]">Loading…</p></main>;
  return (
    <main>
      <article className="container-wide py-10 lg:py-16 max-w-3xl">
        <Link to="/blog" className="text-sm text-[hsl(var(--navy))] inline-flex items-center gap-1 mb-6"><ArrowLeft className="h-4 w-4" /> All posts</Link>
        <div className="flex items-center gap-2"><Badge className="badge-navy border">{post.category}</Badge><span className="text-xs text-[hsl(var(--muted-ink))] inline-flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {fmt(post.published_at)}</span><span className="text-xs text-[hsl(var(--muted-ink))] inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {post.read_min} min</span></div>
        <h1 className="heading-1 mt-4 text-4xl">{post.title}</h1>
        <p className="lead mt-3">{post.excerpt}</p>
        <div className="mt-8 aspect-[16/9] rounded-2xl overflow-hidden border border-[hsl(var(--border))]"><img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" /></div>
        <div className="mt-8 whitespace-pre-line text-[hsl(var(--ink))] leading-relaxed">{post.content}</div>
        <div className="mt-10 text-sm text-[hsl(var(--muted-ink))]">Written by <span className="text-[hsl(var(--navy))] font-semibold">{post.author}</span></div>
      </article>
    </main>
  );
}
